const genericUrl = process.env.REACT_APP_API_URL;

export interface CreateShopItemBody {
    idAula: string;
    nom: string;
    descr: string;
    cost: number;
    stock: number;
    type: string;
    idGameItem: number | null;
}

export async function PostCreateShopItem(body: CreateShopItemBody) {
    try {
        const response = await fetch(`${genericUrl}:8061/jutge/shop/admin/item`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });

        if (response.ok) return { ok: true };
        else {
            const msg = await response.text();
            return { ok: false, msg };
        }
    } catch (e) {
        console.error(e);
        return { ok: false, msg: "Error de conexión" };
    }
}
